import { signIn, signOut } from 'next-auth/react';

export function useAuthService(): AdminService {
  return {
    loginPassword: async (email, password, callbackUrl) => {
      return await signIn('credentials', {
        redirect: false,
        callbackUrl,
        email,
        password
      });
    },
    loginGoogle: (callbackUrl) => {
      signIn('google', { callbackUrl });
    },
    loginNaver: (callbackUrl) => {
      signIn('naver', { callbackUrl });
    },
    loginKakao: (callbackUrl) => {
      signIn('kakao', { callbackUrl });
    },
    logout: (callbackUrl) => {
      signOut({
        callbackUrl: callbackUrl || `${window.location.origin}/login`
      });
    }
  };
}

interface AdminService {
  loginPassword: (
    email: string,
    password: string,
    callbackUrl: string
  ) => Promise<any>;
  loginGoogle: (callbackUrl: string) => void;
  loginNaver: (callbackUrl: string) => void;
  loginKakao: (callbackUrl: string) => void;
  logout: (callbackUrl?: string) => void;
}
